import React, { useState } from "react";
// import { Grid, Typography } from "@material-ui/core";
import { Icon } from "@iconify/react";
import {
  Grid,
  Typography,
  Box,
  IconButton,
  InputAdornment,
  Autocomplete,
  TextField,
  Stack,
  List,
  ListItem,
  ListItemText
} from "@mui/material";
import { InputField, DatePickerField, SelectField } from "../../FormFields";
import { useField, useFormikContext } from "formik";
import { countries } from "../../../../../_mock_/countries";
import Upload from "../../../../../components/uploadAvatar/Upload";
// import { styled } from "@mui/material/styles";
// import PhotoCamera from "@mui/icons-material/PhotoCamera";

import eyeFill from "@iconify/icons-eva/eye-fill";
import eyeOffFill from "@iconify/icons-eva/eye-off-fill";

const titleName = [
  {
    thai: [
      {
        value: "mr.thai",
        label: "นายนาย (Mr.)"
      },
      {
        value: "mrs.thai",
        label: "นางสาว (Ms.)"
      },
      {
        value: "ms.thai",
        label: "นาง (Mrs.)"
      }
    ],
    eng: [
      {
        value: "mr",
        label: "Mr."
      },
      {
        value: "ms",
        label: "Ms."
      },
      {
        value: "mrs",
        label: "Mrs."
      }
    ]
  }
];

const genderOption = [
  {
    value: "male",
    label: "Male"
  },
  {
    value: "female",
    label: "Female"
  }
];

const maritalStatusOption = [
  { value: "single", label: "Single" },
  { value: "married", label: "Married" },
  { value: "widowed", label: "Widowed" },
  { value: "divorce", label: "Divorce" }
];

const bloodTypeOption = [
  {
    value: "a",
    label: "A"
  },
  {
    value: "b",
    label: "B"
  },
  {
    value: "ab",
    label: "AB"
  },
  {
    value: "o",
    label: "O"
  }
];

// const Input = styled("input")({
//   display: "none"
// });

export default function PersonalInformation1(props) {
  const formikProps = useFormikContext();

  const {
    formField: {
      photo,
      email,
      password,
      titleNameEng,
      firstNameEng,
      middleNameEng,
      lastNameEng,
      titleNameThai,
      firstNameThai,
      middleNameThai,
      lastNameThai,
      studentId,
      gender,
      dateOfBirth,
      maritalStatus,
      bloodType,
      idCard,
      nationality
    }
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [nationalityField, nationalityMeta] = useField(nationality);

  return (
    <>
      <Box sx={{ marginBottom: 3 }}>
        <Typography variant="h6" gutterBottom>
          Personal Information
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={12}>
          <Stack direction="row" spacing={12}>
            <Upload photo={photo} />

            <List>
              <Typography variant="subtitle2">
                This photo will be used for a picture for Chula ID card. Please
                prepare a photo as follows:
              </Typography>
              <ListItem sx={{ paddingTop: 5 }}>
                <ListItemText primary="- Picture size: width 1-2 inches, height 1-2 inches" />
              </ListItem>
              <ListItem>
                <ListItemText primary="- Digital photo size: width 600 pixels (maximum), height 600 pixels (maximum)" />
              </ListItem>
              <ListItem>
                <ListItemText primary="- Resolution: 600 DPI" />
              </ListItem>
              <ListItem>
                <ListItemText primary="- Background color: blue or white" />
              </ListItem>
            </List>
          </Stack>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            type="email"
            name={email.name}
            label={email.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            autoComplete="current-password"
            type={showPassword ? "text" : "password"}
            name={password.name}
            label={password.label}
            fullWidth
            variant="outlined"
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <Icon icon={showPassword ? eyeFill : eyeOffFill} />
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <SelectField
            name={titleNameEng.name}
            label={titleNameEng.label}
            data={titleName[0].eng}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <InputField
            name={firstNameEng.name}
            label={firstNameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={middleNameEng.name}
            label={middleNameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={lastNameEng.name}
            label={lastNameEng.label}
            fullWidth
            variant="outlined"
          />
        </Grid>

        <Grid item xs={12} sm={4}>
          <SelectField
            name={titleNameThai.name}
            label={titleNameThai.label}
            data={titleName[0].thai}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={8}>
          <InputField
            name={firstNameThai.name}
            label={firstNameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={middleNameThai.name}
            label={middleNameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputField
            name={lastNameThai.name}
            label={lastNameThai.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={studentId.name}
            label={studentId.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            name={gender.name}
            label={gender.label}
            data={genderOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <DatePickerField
            name={dateOfBirth.name}
            label={dateOfBirth.label}
            inputFormat="dd/MM/yyyy"
            disableFuture
            minDate={new Date("1950/12/31")}
            // views={["year", "month", "date"]}
            // maxDate={new Date()}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            name={maritalStatus.name}
            label={maritalStatus.label}
            data={maritalStatusOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <SelectField
            name={bloodType.name}
            label={bloodType.label}
            data={bloodTypeOption}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <InputField
            name={idCard.name}
            label={idCard.label}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={12}>
          <Autocomplete
            options={countries}
            onChange={(e, result) => {
              formikProps.setFieldValue(nationality.name, result.label);
            }}
            value={nationalityField.value || null}
            isOptionEqualToValue={(option, value) => option?.label === value}
            renderOption={(props, option) => (
              <Box
                component="li"
                sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                {...props}
              >
                <img
                  loading="lazy"
                  width="20"
                  src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                  srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                  alt=""
                />
                {option.label} ({option.code}){/* +{option.phone} */}
              </Box>
            )}
            renderInput={(params) => (
              <TextField
                name={nationalityField.name}
                label={nationality.label}
                error={Boolean(
                  nationalityMeta.touched && nationalityMeta.error
                )}
                helperText={nationalityMeta.touched && nationalityMeta.error}
                {...params}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  );
}
